import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const NavbarLinks = ({ isOpen }) => {
  const [activeLink, setActiveLink] = useState(""); 

  const handleResize = () => {
    if (window.innerWidth > 768) {
      setActiveLink(""); // Reset dropdown state on larger screen sizes
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleDropdownClick = (linkName, e) => {
    e.preventDefault();
    // Toggle dropdown only on mobile
    if (window.innerWidth <= 768) {
      setActiveLink(activeLink === linkName ? "" : linkName);
    }
  };

  return (
    <div
      className={`collapse navbar-collapse ${isOpen ? "show" : ""}`}
      id="navbarNav"
      style={{ overflowX: "hidden" }} // Prevent horizontal scrolling in navbar
    >
      <ul className="navbar-nav ms-auto align-items-center">
        {/* Home Link */}
        <li className="nav-item">
          <a className="nav-link" href="/">
            Home
          </a>
        </li>

        {/* About Dropdown */}
        <li
          className={`nav-item dropdown position-static ${activeLink === "about" ? "mobile-open" : ""}`}
        >
          <a
            className="nav-link"
            href="#about"
            id="aboutDropdown"
            role="button"
            aria-expanded={activeLink === "about" ? "true" : "false"}
            onClick={(e) => handleDropdownClick("about", e)}
          >
            About
            {/* Mobile Toggle Icon */}
            <span className="ms-2 d-md-none">
              {activeLink === "about" ? "-" : "+"}
            </span>
          </a>

          {/* Dropdown menu */}
          <div
            className="dropdown-menu dropdown-common mega-dropdown-menu text-center"
            aria-labelledby="aboutDropdown"
            style={{
              display: activeLink === "about" || window.innerWidth > 768 ? "block" : "none",
              maxWidth: "100%",
              overflowX: "hidden", // Prevent horizontal scrolling inside dropdown
            }}
          >
            <div className="row">
              <div className="col-lg-3 col-md-3">
                <ul className="list-unstyled">
                  <li className="d-flex align-items-center mb-3">
                    <i
                      className="bi bi-bullseye me-2 text-primary"
                      style={{ fontSize: "25px" }}
                    ></i>
                    <Link to="/vision" className="dropdown-item">
                      Vision & Mission
                    </Link>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <i
                      className="bi bi-lightbulb me-2 text-success"
                      style={{ fontSize: "25px" }}
                    ></i>
                    <a href="/coming-soon" className="dropdown-item">
                      Our Philosophy
                    </a>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <i
                      className="bi bi-people-fill me-2 text-info"
                      style={{ fontSize: "25px" }}
                    ></i>
                    <a href="/team" className="dropdown-item">
                      Team
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-lg-3 col-md-3">
                <ul className="list-unstyled">
                  <li className="d-flex align-items-center mb-3">
                    <i
                      className="bi bi-wallet2 me-2 text-warning"
                      style={{ fontSize: "25px" }}
                    ></i>
                    <a href="/coming-soon" className="dropdown-item">
                      Financials
                    </a>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <i
                      className="bi bi-journal-text me-2 text-danger"
                      style={{ fontSize: "25px" }}
                    ></i>
                    <a href="/coming-soon" className="dropdown-item">
                      Reports
                    </a>
                  </li>
                  <li className="d-flex align-items-center mb-3">
                    <i
                      className="bi bi-envelope-at me-2 text-secondary"
                      style={{ fontSize: "25px" }}
                    ></i>
                    <a href="/coming-soon" className="dropdown-item">
                      Contact Us
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </li>

        {/* Programs Dropdown */}
        <li
          className={`nav-item dropdown position-static ${activeLink === "programs" ? "mobile-open" : ""}`}
        >
          <a
            className="nav-link"
            href="/"
            id="programsDropdown"
            role="button"
            aria-expanded={activeLink === "programs" ? "true" : "false"}
            onClick={(e) => {
              e.preventDefault();
              // Toggle dropdown only for mobile view
              if (window.innerWidth <= 768) {
                setActiveLink(activeLink === "programs" ? "" : "programs");
              }
            }}
          >
            Programs
            {/* Mobile view toggle icon */}
            <span className="ms-2 d-md-none">
              {activeLink === "programs" ? "-" : "+"}
            </span>
          </a>

          {/* Dropdown menu */}
          <div
            className="dropdown-menu dropdown-common mega-dropdown-menu text-center"
            aria-labelledby="programsDropdown"
            style={{
              display: activeLink === "programs" || window.innerWidth > 768 ? "block" : "none",
              maxWidth: "100%",
              overflowX: "hidden", // Prevent horizontal scrolling inside dropdown
            }}
          >
            <div className="row">
              {/* Education */}
              <div className="col-lg-3 col-md-6">
                <h6 className="dropdown-header text-danger">
                  <i
                    className="fas fa-graduation-cap me-2"
                    style={{ fontSize: "28px" }}
                  ></i>{" "}
                  Education
                </h6>
                <ul className="list-unstyled">
                  <li>
                    <a className="dropdown-item" href="/coming-soon">
                      NMMS
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/coming-soon">
                      Education Roadmap
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/coming-soon">
                      STEM
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/coming-soon">
                      Robotics
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/coming-soon">
                      MDRS
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/coming-soon">
                      JNV
                    </a>
                  </li>
                </ul>
              </div>

              {/* Health */}
              <div className="col-lg-3 col-md-6">
                <h6 className="dropdown-header text-primary">
                  <i
                    className="fas fa-heartbeat me-2"
                    style={{ fontSize: "28px" }}
                  ></i>{" "}
                  Health
                </h6>
                <ul className="list-unstyled">
                  <li>
                    <a className="dropdown-item" href="/coming-soon">
                      Satvik Aahar
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/coming-soon">
                      Yoga for Fitness
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/coming-soon">
                      Satvik Dinacharya
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/coming-soon">
                      Guidance to Exercise
                    </a>
                  </li>
                </ul>
              </div>

              {/* Women Empowerment */}
              <div className="col-lg-3 col-md-6">
                <h6 className="dropdown-header text-warning">
                  <i
                    className="fas fa-fist-raised me-2"
                    style={{ fontSize: "28px" }}
                  ></i>{" "}
                  Women Empowerment
                </h6>
                <ul className="list-unstyled">
                  <li>
                    <a className="dropdown-item" href="/coming-soon">
                      Hoop Art Mastery
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/coming-soon">
                      Entrepreneurship
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/coming-soon">
                      Self Defense
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/coming-soon">
                      Social Media Awareness
                    </a>
                  </li>
                </ul>
              </div>

              {/* Seminar/Workshop */}
              <div className="col-lg-3 col-md-6">
                <h6 className="dropdown-header text-success">
                  <i
                    className="fas fa-chalkboard-teacher me-2"
                    style={{ fontSize: "28px" }}
                  ></i>{" "}
                  Seminar/Workshop
                </h6>
                <ul className="list-unstyled">
                  <li>
                    <a className="dropdown-item" href="/coming-soon">
                      Cyber Security
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/coming-soon">
                      E-Content Creation
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/coming-soon">
                      3D Model
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/coming-soon">
                      Graphic Designing
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/coming-soon">
                      Video Editing
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="/coming-soon">
                      IT Techs
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </li>
        {/* Gallery Dropdown */}
        <li className="nav-item">
          <a className="nav-link" href="/gallery">
            Gallery
          </a>
        </li>

        {/* Donate Dropdown */}
        <li
          className={`nav-item dropdown position-static ${activeLink === "donate" ? "mobile-open" : ""}`}
        >
          <a
            className="nav-link"
            href="/donate"
            id="donateDropdown"
            role="button"
            aria-expanded={activeLink === "donate" ? "true" : "false"}
            onClick={(e) => {
              // Prevent default navigation behavior on mobile only
              if (window.innerWidth <= 768) {
                e.preventDefault(); // Prevent default behavior to stop navigation (mobile only)
                // Toggle dropdown visibility for mobile view
                setActiveLink(activeLink === "donate" ? "" : "donate");
              }
            }}
          >
            Donate
            {/* Mobile view toggle icon */}
            <span className="ms-2 d-md-none">
              {activeLink === "donate" ? "-" : "+"}
            </span>
          </a>

          {/* Dropdown menu */}
          <div
            className="dropdown-menu dropdown-common mega-dropdown-menu "
            aria-labelledby="donateDropdown"
            style={{
              maxWidth: "1145px",
              display:
                activeLink === "donate" || window.innerWidth > 768 ? "block" : "none",
            }}
          >
            <div className="row">
              {/* Donate Options (Two Columns) */}
              <div className="col-lg-6 col-md-6">
                <ul className="list-unstyled">
                  <li
                    className="d-flex align-items-center mb-3"
                    style={{ fontSize: "18px" }}
                  >
                    <i
                      className="bi bi-person-fill me-2 text-primary"
                      style={{ fontSize: "24px" }}
                    ></i>
                    <a href="/coming-soon" className="dropdown-item">
                      Sponsor a child
                    </a>
                  </li>
                  <li
                    className="d-flex align-items-center mb-3"
                    style={{ fontSize: "18px" }}
                  >
                    <i
                      className="bi bi-boxes me-2 text-success"
                      style={{ fontSize: "24px" }}
                    ></i>
                    <a href="/coming-soon" className="dropdown-item">
                      Sponsor a school kit
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-lg-6 col-md-6">
                <ul className="list-unstyled">
                  <li
                    className="d-flex align-items-center mb-3"
                    style={{ fontSize: "18px" }}
                  >
                    <i
                      className="bi bi-book-fill me-2 text-warning"
                      style={{ fontSize: "24px" }}
                    ></i>
                    <a href="/coming-soon" className="dropdown-item">
                      Sponsor Books and Study materials
                    </a>
                  </li>
                  <li
                    className="d-flex align-items-center mb-3"
                    style={{ fontSize: "18px" }}
                  >
                    <i
                      className="bi bi-currency-dollar me-2 text-danger"
                      style={{ fontSize: "24px" }}
                    ></i>
                    <a href="/coming-soon" className="dropdown-item">
                      Way to Give (Money)
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </li>



        {/* Get Involved Dropdown */}
        <li
          className={`nav-item dropdown position-static ${activeLink === "get involved" ? "mobile-open" : ""
            }`}
        >
          <a
            className="nav-link"
            href="/"
            id="getInvolvedDropdown"
            role="button"
            aria-expanded={activeLink === "get involved" ? "true" : "false"}
            onClick={(e) => {
              e.preventDefault();
              // Toggle dropdown for mobile view
              if (window.innerWidth <= 768) {
                setActiveLink(activeLink === "get involved" ? "" : "get involved");
              }
            }}
          >
            Get Involved
            {/* Mobile view toggle icon */}
            <span className="ms-2 d-md-none">
              {activeLink === "get involved" ? "-" : "+"}
            </span>
          </a>

          {/* Dropdown menu */}
          <div
            className="dropdown-menu dropdown-common mega-dropdown-menu "
            aria-labelledby="getInvolvedDropdown"
            style={{
              maxWidth: "1130px",
              backgroundColor: "#f8f9fa",
              display:
                activeLink === "get involved" || window.innerWidth > 768
                  ? "block"
                  : "none",
            }}
          >
            <div className="row">
              {/* Volunteer Section */}
              <div className="col-lg-6 col-md-6">
                <h6
                  className="dropdown-header text-primary d-flex align-items-center"
                  style={{
                    fontSize: "20px",
                    whiteSpace: "nowrap",
                    marginBottom: "0",
                  }}
                >
                  <i
                    className="bi bi-person-fill me-2"
                    style={{ fontSize: "24px" }}
                  ></i>
                  Volunteer
                </h6>
                <ul className="list-unstyled">
                  <li style={{ marginBottom: "1px" }}>
                    <a href="/volunteer-teacher" className="dropdown-item">
                      Volunteer as a Teacher
                    </a>
                  </li>
                  <li style={{ marginBottom: "1px" }}>
                    <a href="/join-intern" className="dropdown-item">
                      Join as an Intern
                    </a>
                  </li>
                  <li style={{ marginBottom: "1px" }}>
                    <a href="/volunteer-mentor" className="dropdown-item">
                      Volunteer as a Mentor
                    </a>
                  </li>
                </ul>
              </div>
              {/* CSR, Career, Partner with Us */}
              <div className="col-lg-6 col-md-6">
                <ul className="list-unstyled">
                  <li
                    style={{ fontSize: "18px", marginBottom: "15px" }}
                  >
                    <i
                      className="bi bi-hand-thumbs-up me-2"
                      style={{ fontSize: "20px", color: "#e74c3c" }}
                    ></i>
                    CSR Collaborations
                  </li>
                  <li
                    style={{ fontSize: "18px", marginBottom: "15px" }}
                  >
                    <i
                      className="bi bi-briefcase me-2"
                      style={{ fontSize: "20px", color: "#f39c12" }}
                    ></i>
                    Career
                  </li>
                  <li
                    style={{ fontSize: "18px", marginBottom: "15px" }}
                  >
                    <i
                      className="bi bi-people-fill me-2"
                      style={{ fontSize: "20px", color: "#3498db" }}
                    ></i>
                    Partner with us
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </li>

        <li className="nav-item">
          <a className="nav-link d-flex justify-content-between" href="/participate">
            Participate
            <span className="ms-2 d-md-none">{activeLink === "participate" ? "-" : "+"}</span> {/* Mobile view */}
            <span className="ms-2 d-none d-md-inline">{activeLink === "participate" ? "-" : ""}</span> {/* Desktop view */}
          </a>
        </li>
        {/* News & Stories Dropdown */}
        <li
          className={`nav-item dropdown position-static ${activeLink === "news" ? "mobile-open" : ""
            }`}
        >
          <a
            className="nav-link"
            href="/"
            id="newsDropdown"
            role="button"
            aria-expanded={activeLink === "news" ? "true" : "false"}
            onClick={(e) => {
              e.preventDefault();
              // Toggle dropdown for mobile view
              if (window.innerWidth <= 768) {
                setActiveLink(activeLink === "news" ? "" : "news");
              }
            }}
          >
            News & Stories
            {/* Mobile view toggle icon */}
            <span className="ms-2 d-md-none">
              {activeLink === "news" ? "-" : "+"}
            </span>
          </a>

          {/* Dropdown menu */}
          <div
            className="dropdown-menu dropdown-common mega-dropdown-menu"
            aria-labelledby="newsDropdown"
            style={{
              maxWidth: "1145px",
              display:
                activeLink === "news" || window.innerWidth > 768
                  ? "block"
                  : "none",
            }}
          >
            <div className="row">
              {/* Blogs and Notifications */}
              <div className="col-lg-6 col-md-6">
                <ul className="list-unstyled">
                  <li className="d-flex align-items-center mb-3" style={{ fontSize: "18px" }}>
                    <i className="bi bi-journal-text me-2 text-primary" style={{ fontSize: "24px" }}></i>
                    <a href="https://blog.sritakshashilagurukul.com/" className="dropdown-item" target="_blank" rel="noopener noreferrer">Blogs</a>
                  </li>
                  <li className="d-flex align-items-center mb-3" style={{ fontSize: "18px" }}>
                    <i className="bi bi-bell me-2 text-success" style={{ fontSize: "24px" }}></i>
                    <a href="/coming-soon" className="dropdown-item">Notification</a>
                  </li>
                </ul>
              </div>
              {/* Newsletters and Our Books */}
              <div className="col-lg-6 col-md-6">
                <ul className="list-unstyled">
                  <li className="d-flex align-items-center mb-3" style={{ fontSize: "18px" }}>
                    <i className="bi bi-envelope me-2 text-warning" style={{ fontSize: "24px" }}></i>
                    <a href="/coming-soon" className="dropdown-item">Newsletters</a>
                  </li>
                  <li className="d-flex align-items-center mb-3" style={{ fontSize: "18px" }}>
                    <i className="bi bi-book-half me-2 text-danger" style={{ fontSize: "24px" }}></i>
                    <a href="/coming-soon" className="dropdown-item">Our Books</a>
                  </li>
                </ul>
              </div>

              {/* Magazines */}
              <div className="col-lg-6 col-md-6">
                <ul className="list-unstyled">
                  <li className="d-flex align-items-center mb-3" style={{ fontSize: "18px" }}>
                    <i className="bi bi-file-earmark-text me-2 text-primary" style={{ fontSize: "24px" }}></i>
                    <a href="/coming-soon" className="dropdown-item">Magazines</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </li>

        {/* <li className="nav-item">
          <a className="nav-link" href="/login">
            Login
          </a>
        </li> */}
      </ul>
    </div >
  );
};

export default NavbarLinks;
